export default "__VITE_ASSET__CUisMZ90__"